<div class="alert alert-danger" *ngIf="errorMsg">{{errorMsg}}</div>
<div id="timeline"
  class="clearfix"
  *ngIf="timelineData"
  [chartData]="timelineData"
  [chartOptions] = "timelineOptions"
  [selectionCallback] = "selectionCallback"
  chartType="Timeline"
  GoogleChart></div>